import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Switch, Route } from 'react-router-dom';
import moment from 'moment';
import { PageHeader, Result, Skeleton, Descriptions } from 'antd';
import history from '@utils/history';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import {
  transformStripePrice,
  transformAddonKeyToTitle
} from '@services/transform';

function ViewRequestPage(props) {
  const {
    loadig,
    loadBooking,
    resetBooking,
    bookingData,
    match: { params, url }
  } = props;

  const { id: bookingId } = params || {};

  if (!bookingId) {
    return (
      <div className="properties main-page">
        <PageHeader
          title="Booking"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="booking main-content">
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        </div>
      </div>
    );
  }

  const renderBooking = () => {
    // bookingID: 101703,
    // serviceType: 'hotel-style',
    // additionalService: [
    //   'mopping-clean'
    // ],
    // timeframe: 'anytime',
    // notes: null,
    // price: 6700,
    // duration: 95,
    // serviceDate: '2020-01-10T00:00:00.000Z',
    // createdAt: '2019-12-12T14:15:22.908Z',
    // propertySettings: 95,
    // globalSettings: 1,
    // status: 'confirmed',
    // couponID: null,
    // userID: 16293,
    // propertyID: 95,
    // housekeeperID: null,
    // startTime: null,
    // endTime: null,
    // deputyRosterID: null,
    // rating: null,
    // ratingComment: null,
    // cost: {
    //   cost: 6700,
    //   duration: 95,
    //   addonsPrice: [
    //     {
    //       addon: 'mopping-clean',
    //       addonCost: 2500
    //     }
    //   ],
    //   couponDetails: {},
    //   baseServiceCost: 4200,
    //   beforeDiscountCost: 6700
    // },
    // firstName: 'Test4',
    // lastName: 'User',
    // email: 'test4@example.com',
    // bedroomsCount: 2,
    // buildingName: null,
    // unitNumber: 'A123',
    // bookedBy: 'member',
    // isRecurring: false,
    // recurringBookingID: null,
    // airtableID: null,
    // airtableDelta: null,
    // state: 'Illinois',
    // city: 'Chicago',
    // propertyName: 'The Minte App Launch',
    // regionID: 3,
    // regionName: 'Chicago Region'

    const {
      serviceType,
      additionalService,
      timeframe,
      notes,
      internalNotes,
      price,
      serviceDate,
      createdAt,
      status,
      propertyID,
      rating,
      ratingComment,
      cost,
      userID,
      firstName,
      lastName,
      email,
      bedroomsCount,
      buildingName,
      unitNumber,
      startTime,
      endTime,
      propertyName,
      regionName,
      houseKeeper
    } = bookingData;

    const { cost: totalCost, duration, couponDetails, beforeDiscountCost } =
      cost || {};

    const { firstName: hFirstName, lastName: hLastName } = houseKeeper || {};
    const houseKeeperName = houseKeeper ? `${hFirstName} ${hLastName}` : '';

    const title = `${firstName} ${lastName} - ${
      propertyName ? propertyName : 'NO PROPERTY'
    }`;

    return (
      <div className="properties main-page">
        <PageHeader
          title={title}
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        >
          <div
            className="content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '80%'
              }}
            >
              <Descriptions size="small" column={3}>
                <Descriptions.Item label="Client Name">
                  <Link
                    to={`/clients/${userID}`}
                  >{`${firstName} ${lastName}`}</Link>
                </Descriptions.Item>
                <Descriptions.Item label="Email">{email}</Descriptions.Item>
                <Descriptions.Item label="Created">
                  {moment(createdAt).format('LLL')}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </div>
        </PageHeader>

        <div className="main-content booking">
          <Descriptions bordered column={3} title="Service Information">
            <Descriptions.Item label="Status">{status}</Descriptions.Item>
            <Descriptions.Item label="Service">{serviceType}</Descriptions.Item>
            <Descriptions.Item label="Additional Service">
              {additionalService &&
                additionalService.map(transformAddonKeyToTitle).join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Timeframe">{timeframe}</Descriptions.Item>
            <Descriptions.Item label="Service Date" span={2}>
              {moment(serviceDate).format('LLL')}
            </Descriptions.Item>
            <Descriptions.Item label="Notes" span={3}>
              {notes}
            </Descriptions.Item>
            <Descriptions.Item label="Internal Notes" span={3}>
              {internalNotes}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions bordered column={2} title="Price Information">
            <Descriptions.Item label="Price">
              ${transformStripePrice(price)}
            </Descriptions.Item>
            <Descriptions.Item label="Duration">{duration}</Descriptions.Item>
            <Descriptions.Item label="After Discount">
              ${transformStripePrice(totalCost)}
            </Descriptions.Item>
            <Descriptions.Item label="Before Discount">
              ${transformStripePrice(beforeDiscountCost)}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions bordered column={3} title="Other Information">
            <Descriptions.Item label="House Keeper">
              {houseKeeperName}
            </Descriptions.Item>
            <Descriptions.Item label="Start Time">
              {startTime}
            </Descriptions.Item>
            <Descriptions.Item label="End Time">{endTime}</Descriptions.Item>
            <Descriptions.Item label="Rating">{rating}</Descriptions.Item>
            <Descriptions.Item label="Review" span={2}>
              {ratingComment}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions bordered column={3} title="Property Information">
            <Descriptions.Item label="Property">
              <Link to={`/properties/${propertyID}`}>{propertyName}</Link>
            </Descriptions.Item>
            <Descriptions.Item label="Building" span={2}>
              {buildingName}
            </Descriptions.Item>
            <Descriptions.Item label="Unit Number">
              {unitNumber}
            </Descriptions.Item>
            <Descriptions.Item label="No of Bedrooms">
              {bedroomsCount}
            </Descriptions.Item>
            <Descriptions.Item label="Region">{regionName}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  };

  useEffect(() => {
    loadBooking(bookingId);

    return () => {
      resetBooking();
    };
  }, [bookingId]);

  if (loadig) {
    return (
      <div className="properties main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="booking main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  return (
    <Switch>
      <Route exact path={`${url}/`}>
        {renderBooking()}
      </Route>
    </Switch>
  );
}

ViewRequestPage.propTypes = {
  match: PropTypes.object,
  loadBooking: PropTypes.func,
  resetBooking: PropTypes.func,
  loadig: PropTypes.bool,
  bookingData: PropTypes.object
};

const mapStateToProps = state => ({
  loadig: BookingSelectors.selectIsLoading(state),
  bookingData: BookingSelectors.selectBookingData(state)
});

const mapDispatchToProps = dispatch => ({
  loadBooking: bookingId => {
    dispatch(BookingActions.loadBookingRequest(bookingId));
  },
  resetBooking: () => dispatch(BookingActions.resetBooking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewRequestPage);
